import React from 'react'
import { CreateJobPreviewComp } from './PreviewComp'

interface StepFourProps {
  goToStep: (step: number) => void
}

export const CreateJobStepFourComp = ({ goToStep }: StepFourProps) => {
  return (
    <div className='form-step'>
      <CreateJobPreviewComp goToStep={goToStep} />
    </div>
  )
}
